import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { Result } from '../models/result';
import { toAppError } from '../utils/error.util';
import { GatewayConfig } from './gateway-config.state';

@Injectable({ providedIn: 'root' })
export class GatewayConfigApi {
  readonly #http = inject(HttpClient);

  get(): Observable<Result<GatewayConfig>> {
    return this.#http.get<GatewayConfig>(`${environment.apiUrl}payment/gateway-config`).pipe(
      map(data => ({ ok: true as const, data })),
      catchError(err => of({ ok: false as const, error: toAppError(err) })),
    );
  }
}
